let ViewState = {
    table: 'tableView',
    detail: 'detailView',
    about: 'aboutView'
};

export default ViewState;


// WEBPACK FOOTER //
// ./src/ViewState.js